import { render } from "./DayPicks.vue?vue&type=template&id=f3304986"
import script from "./DayPicks.vue?vue&type=script&lang=ts"
export * from "./DayPicks.vue?vue&type=script&lang=ts"
script.render = render

export default script